/* The trips index. */
.page {
  display: grid;
  gap: var(--dimension-space-4);
  max-width: 880px;
  padding: var(--dimension-space-5);
}
.title {
  margin: 0;
}
.muted {
  color: var(--color-text-secondary);
}
.list {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.trip {
  display: block;
  color: var(--color-text-primary);
  text-decoration: none;
}
.trip:hover {
  outline: var(--dimension-line-hairline) solid var(--color-border-control);
}
.group {
  margin: var(--dimension-space-4) 0 var(--dimension-space-1);
  color: var(--color-text-secondary);
}
.form {
  display: grid;
  gap: var(--dimension-space-2);
  margin-top: var(--dimension-space-4);
}
.form h2 {
  margin: 0;
}
